import {
  CREATE_CATEGORY,
  UPDATE_CATEGORY,
  UNLOAD_CATEGORY,
  CATEGORY_FETCHED_SUCCESS,
  SUB_CATEGORY_FETCHED_SUCCESS,
  PUSHED_CATEGORY,
  PUSHED_SUB_CATEGORY,
  CATEGORY_TOGGLE_FAILED,
  CATEGORY_TOGGLE_SUCCESS,
  SUB_CATEGORY_TOGGLE_FAILED,
  SUB_CATEGORY_TOGGLE_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
  categories: [],
  subCategories: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CATEGORY:
    case UPDATE_CATEGORY:
      return {
        ...state,
        errors: action.payload.errors,
        message: action.payload.msg,
      };

    case UNLOAD_CATEGORY:
      return initialState;

    case PUSHED_CATEGORY:
      return {
        ...state,
        categories: state.categories.map((item) => {
          if (item.id === action.payload.id) {
            const newItem = { ...item };
            newItem.pushed_at = action.payload.date;
            return newItem;
          }
          return item;
        }),
      };

    case PUSHED_SUB_CATEGORY:
      return {
        ...state,
        subCategories: state.subCategories.map((item) => {
          if (item.id === action.payload.id) {
            const newItem = { ...item };
            newItem.pushed_at = action.payload.date;
            return newItem;
          }
          return item;
        }),
      };

    case CATEGORY_TOGGLE_FAILED:
      return state;

    case CATEGORY_TOGGLE_SUCCESS:
      return {
        ...state,
        categories: state.categories.map((item) => {
          if (item.id !== action.payload.id) return item;
          const newItem = { ...item };
          newItem.is_active = action.payload.active;
          return newItem;
        }),
      };

    case SUB_CATEGORY_TOGGLE_FAILED:
      return state;

    case SUB_CATEGORY_TOGGLE_SUCCESS:
      return {
        ...state,
        subCategories: state.subCategories.map((item) => {
          if (item.id !== action.payload.id) return item;
          const newItem = { ...item };
          newItem.is_active = action.payload.active;
          return newItem;
        }),
      };

    case CATEGORY_FETCHED_SUCCESS:
      return {
        ...state,
        categories: action.payload.categories.map((item) => {
          const newItem = { ...item, id: item.id };
          return newItem;
        }),
        pager: action.payload.pager,
      };

    case SUB_CATEGORY_FETCHED_SUCCESS:
      return {
        ...state,
        subCategories: action.payload.subCategories.map((item) => {
          const newItem = { ...item, id: item.id };
          return newItem;
        }),
        pager: action.payload.pager,
      };

    default:
      return state;
  }
};
